import React, { useState } from 'react';

const LinkSection = ({ sectionData, baseUrl }) => {
  const [activeAccordion, setActiveAccordion] = useState(null);

  if (!sectionData) return null;

  const toggleAccordion = (id) => {
    setActiveAccordion(activeAccordion === id ? null : id);
  };

  // Helper to check if a URL is external (starts with http:// or https://)
  const isExternalLink = (url) => {
    return url && (url.startsWith('http://') || url.startsWith('https://'));
  };

  return (
    <section className="mt-0 mt-md-5 mb-5">
      <div className="container">
        <div className="accordion" id="ihecAccordion">
          
          {sectionData.map((item) => {
            const collapseId = `collapse-${item.id}`;
            const isActive = activeAccordion === collapseId;

            return (
              <div className="accordion-item" key={item.id}>
                <h2 className="accordion-header">
                  <button
                    className={`accordion-button ${isActive ? '' : 'collapsed'}`}
                    type="button"
                    onClick={() => toggleAccordion(collapseId)}
                  >
                    {item.heading}
                  </button>
                </h2>
                <div
                  id={collapseId}
                  className={`accordion-collapse collapse ${isActive ? 'show' : ''}`}
                >
                  <div className="accordion-body">
                    {item.pdfs && item.pdfs.length > 0 ? (
                      item.pdfs.map((pdf, pdfIndex) => {
                        const isExternal = isExternalLink(pdf.url);
                        
                        // Logic: 
                        // If external -> Use URL as is.
                        // If internal -> Append /public/ before storage path (based on your requirement).
                        const linkHref = isExternal 
                          ? pdf.url 
                          : `${baseUrl}/public/${pdf.url}`;

                        return (
                          <div className="mb-2" key={pdfIndex}>
                            {/* Dynamic Icon: Link icon for external, PDF icon for internal */}
                            <i className={`fa ${isExternal ? 'fa-external-link' : 'fa-file-pdf-o'} text-danger me-2`}></i>
                            
                            <a 
                              className="style4" 
                              href={linkHref} 
                              target="_blank" 
                              rel="noopener noreferrer"
                            >
                              {pdf.name}
                            </a>
                          </div>
                        );
                      })
                    ) : (
                      <p>No documents available.</p>
                    )}
                  </div>
                </div>
              </div>
            );
          })}

        </div>
      </div>
    </section>
  );
};

export default LinkSection;